<template>
  <div>
    <SlottedContainerComponent
      v-if="documents.length > 0"
      :buttonText="
        $t('dashboard.documents.expand', { document_count: documents.length })
      "
      :expandable="true"
      :containerClass="`bg-white px-3 border-translucent`"
    >
      <template #title>
        <h4 class="my-2 font-serif">
          {{
            $t("dashboard.documents.section_title", {
              document_count: documents.length,
            })
          }}
        </h4>
      </template>
      <template #content>
        <DocumentCardComponent
          v-for="document in documents"
          :key="document.id"
          :document="document"
          :account_id="account_id"
          :is_admin="is_admin"
          :generator="getAssociatedGenerator(document)"
        />
      </template>
    </SlottedContainerComponent>
    <PlaceholderCardComponent
      v-else-if="showPlaceholder"
      :title="$t('dashboard.documents.no_documents')"
      :subtitle="$t('dashboard.documents.no_documents_message')"
    />
  </div>
</template>

<script setup lang="ts">
import PlaceholderCardComponent from "@/components/common/PlaceholderCardComponent.vue";
import SlottedContainerComponent from "@/components/common/SlottedContainerComponent.vue";
import DocumentCardComponent from "@/dashboard/invoice_management/DocumentCardComponent.vue";
import type { Document, Generator } from "@/types";

const props = withDefaults(
  defineProps<{
    documents: Document[];
    generators: Generator[];
    account_id: number;
    is_admin: boolean;
    showPlaceholder?: boolean;
  }>(),
  {
    showPlaceholder: true, // Default to showing the placeholder
  }
);

const getAssociatedGenerator = (document: Document) => {
  if (!document.generator_id) {
    return undefined;
  }
  return props.generators.find(
    (generator: Generator) => generator.id === document.generator_id
  );
};
</script>
